/**
 * Created by user on bank bundle files implementation.
 */

class BankBundleFileCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private referenceLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private amountLabel:MUILabel = null;

    awakeFromHTML() {
        super.awakeFromHTML();
        
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
    }

    private _item: BankTransferBundleFile = null;
    set item(item: BankTransferBundleFile) {
        this._item = item;
                    
        this.dateLabel.text = item.referenceDateString;                                    
        this.referenceLabel.text = item.reference;
        this.conceptLabel.text = item.concept;
        this.amountLabel.text = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( item.totalAmount );            
    }
}
